<template>
  <ul
    class="lg:tw-gap-2 xl:tw-gap-6 tw-font-medium tw-menu lg:tw-menu-horizontal tw-items-center tw-flex-nowrap tw-relative tw-z-50 tw-px-0 tw-py-0">
    <li v-for="(item, index) in menuList" :key="index" class="tw-w-full lg:tw-w-auto">
      <NuxtLinkLocale for="my-drawer" aria-label="close sidebar" v-if="!item.child.length" :to="item.href"
        @click="item?.onClick" class="tw-uppercase tw-text-lg lg:tw-text-base">

        <span class="link" :class="{
          'menu-item-white': isLight,
          'menu-item-black':!isLight
        }">{{ $t(item.name) }}</span>
      </NuxtLinkLocale>
      <UIDetails v-else v-slot="slotProps">
        <summary class="tw-uppercase tw-text-lg lg:tw-text-base" :class="{
            'lg:tw-text-[#b7baca] hover:lg:tw-text-[#fff]': isLight,
            'router-link-active': isActive(item),
          }">
          <span class="link" :class="{
            'menu-item-white': isLight,
            'menu-item-black':!isLight
          }">{{ $t(item.name) }}</span>
        </summary>
        <ul
          class="tw-flex tw-flex-col tw-gap-y-2 lg:tw-shadow-sm hover:lg:tw-shadow-lg lg:tw-rounded-lg  margin-inline-start tw-ms-0 tw-mt-1 before:tw-w-0 lg:tw-border  tw-border-primary tw-transition-all tw-duration-300 tw-ease-in-out hover:-tw-translate-y-1">
          <li v-for="(subItem, subIndex) in item.child" :key="subIndex">
            <NuxtLinkLocale custom :to="subItem.href" v-slot="scoped">
              <label :bind="enClosed ? {} : { for: 'my-drawer' }" aria-label="close sidebar"
                class="tw-text-[#111224] tw-bg-[#111224]/[.02] tw-px-5 tw-py-5 tw-rounded tw-cursor-pointer tw-flex"
                :key="subIndex" @click="goTo(scoped, slotProps.close)">
                <div class="tw-flex tw-flex-nowrap tw-justify-between tw-items-center tw-transition-all hover:tw-text-primary tw-gap-4 hover:tw-gap-6 tw-duration-300 tw-ease-in-out">
                  <div class="tw-flex tw-items-center">
                    <div v-if="subItem.icon" class="tw-mr-2 tw-w-5 tw-h-5">
                      <SvgoCommonIconBankGrey v-if="subItem.icon === 'otc'" />
                      <SvgoCommonIconCryptowallet v-if="subItem.icon === 'pay'" />
                      <SvgoCommonIconTradeWithUs v-if="subItem.icon === 'trade'" />
                      <SvgoCommonLogo v-if="subItem.icon === 'legend'" />
                      <SvgoCommonNews v-if="subItem.icon === 'news'" />
                      <SvgoCommonIconGroup v-if="subItem.icon === 'partner'" />
                      <SvgoCommonIconRing v-if="subItem.icon === 'support'" />
                      <SvgoMenuTreasureBox v-if="subItem.icon === 'treasurebox'" />
                    </div>
                    <span class="tw-text-base tw-uppercase tw-text-nowrap tw-relative">{{ $t(subItem.name) }}
                      <!-- <p class="tw-absolute tw-z-50 tw-text-primary tw-text-xs tw-normal-case tw-scale-90">{{
                        subItem.tip }}</p> -->
                    </span>
                  </div>
                  <SvgoCommonArrow class="tw-w-2 tw-h-4" />
                </div>
              </label>
            </NuxtLinkLocale>
          </li>
        </ul>
      </UIDetails>
    </li>
  </ul>
</template>
<script lang="ts" setup>
const { isZa } = useSite()
const props = defineProps<{
  isLight?: boolean
  enClosed?: boolean
}>()
const zenDesk = useZenDesk()
const menuList = computed(() => {
  if (unref(isZa)) {
    return [
      {
        name: 'Products',
        child: [
          {
            name: 'Legend OTC',
            icon: 'otc',
            //   desc: 'Cryptocurrency OTC Trading Service trusted by 800+ institutions.',
            href: '/legend-otc',
          },
          {
            name: 'Trade with us',
            icon: 'trade',
            href: '/kyc',
          },
        ],
      },
      {
        name: 'Newsroom',
        href: `/newsroom`,
        child: [],
      },
      {
        name: 'Company',
        child: [
          {
            name: 'About us',
            icon: 'legend',
            //   desc: 'We believe the future of global finance should be open to everyone.',
            href: `/about`,
          },
          {
            name: 'Become our partner',
            icon: 'partner',
            href: `/partner`,
          },
          {
            name: 'Support help center',
            icon: 'support',
            href: 'https://support.legendtrading.com/hc/',
          },
        ],
      },
      {
        name: 'CONTACT',
        child: [],
        onClick() {
          onTouched()
        },
      },
    ]
  }
  //     Product/Legend Gateway

  // Showcases

  // Developer
  return [
    {
      name: 'Products',
      child: [
        {
          name: 'Legend OTC',
          icon: 'otc',
          //   desc: 'Cryptocurrency OTC Trading Service trusted by 800+ institutions.',
          href: '/legend-otc',
        },
        {
          name: 'Legend Gateway',
          icon: 'pay',
          //   desc: 'Fiat-Crypto On/Off Ramp service covers 100+ countries and 40+ fiat currencies.',
          href: '/legend-gateway',
        },
        // {
        //   name: 'TreasureBox',
        //   icon: 'treasurebox',
        //   tip: 'Coming soon',
        //   href: 'https://www.treasurebox.com/',
        // },
        // {
        //   name: 'Trade with us',
        //   icon: 'trade',
        //   href: '/kyc',
        // },
      ],
    },
    {
      name: 'Newsroom',
      href: `/newsroom`,
      child: [],
    },
    {
      name: 'Showcases',
      href: `/cases`,
      child: [],
    },
    {
      name: 'Developers',
      href: `/developers`,
      child: [],
    },
    {
      name: 'Company',
      child: [
        {
          name: 'About us',
          icon: 'legend',
          //   desc: 'We believe the future of global finance should be open to everyone.',
          href: `/about`,
        },
        {
          name: 'Become our partner',
          icon: 'partner',
          href: `/partner`,
        },
        {
          name: 'Support help center',
          icon: 'support',
          href: 'https://support.legendtrading.com/hc/',
        },
      ],
    },
    {
      name: 'CONTACT',
      child: [],
      onClick() {
        onTouched()
      },
    },
  ]
})

const isActive = (item: any) => {
  return item.child.some((subItem:any)=>subItem.href === useRoute().path)
}

const onTouched = () => {
  zenDesk.onToggle()
  document.getElementById("my-drawer")?.click()
}

const goTo = (scoped: any, close: () => void) => {
  if ((scoped.href as string).startsWith('http')) {
    setTimeout(() => {
      window.open(scoped.href, '_blank')
    }, 400);
  } else {
    scoped.navigate()
  }

  if (props.enClosed) {
    close()
  } else {
    document.getElementById("my-drawer")?.click()
  }
}
</script>
<style scoped>
.router-link-active .menu-item-white{
  @apply tw-text-white after:tw-w-full;
}

.router-link-active .menu-item-black{
  @apply after:tw-w-full;
}

.menu-item-white {
  @apply lg:tw-text-[#b7baca] hover:lg:tw-text-white after:tw-bg-white;
}

.menu-item-black {
  @apply lg:tw-text-[#000] hover:lg:tw-text-black after:tw-bg-black;
}

.link {
  @apply tw-no-underline tw-transition-colors tw-duration-300 tw-relative tw-tracking-wide after:tw-content-[''] after:tw-absolute after:tw-bottom-[-2px] after:tw-left-0 after:tw-w-0 after:tw-h-0.5 after:tw-transition-all after:tw-duration-300 after:tw-ease-in-out hover:after:tw-w-full
}
</style>